<template>
  <div>
    <transition :name="animations.fadeIn.name" :leave-active-class="animations.fadeIn.leave" :enter-active-class="animations.fadeIn.enter">
      <div class="card user-card" v-if="ready && themaUser">
        <div class="card-body">
          <div class="online-user" style="margin-bottom:20px;">
            <h5 class="font-primary f-18 mb-0">Ihr Ansprechpartner</h5>
          </div>
          <div class="user-card-image">
            <img class="img-fluid rounded-circle image-radius" :src="avatar" alt="" />
          </div>
          <div class="user-deatils text-center">
            <h5>{{ themaUser.first_name }} {{ themaUser.last_name }}</h5>
            <h6>Zuständigkeit: {{ show_themen }}</h6>
          </div>
          <div class="user-badge text-center">
            <a :href="'mailto:' + themaUser.email" class="badge badge-pill badge-light"><feather type="mail" size="20px"></feather></a>
            <a :href="'phone:' + themaUser.telefon" class="badge badge-pill badge-light"><feather type="phone-outgoing" size="20px"></feather></a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Ansprechpartner",
  props: ["show_themen"],
  components: {},
  computed: {
    ...mapGetters({
      toasts: "app/toasts",
      animations: "app/animations",
      themen: "app/themen",
      defaultAvatar: "auth/defaultAvatar",
    }),
  },
  data() {
    return {
      avatar: null,
      themaUser: null,
      loading: {
        themen: false,
      },
      ready: false,
    };
  },
  async created() {
    try {
      this.loading.themen = true;
      await this.$store.dispatch("app/apiGetThemen");
      if (!this.themen.length) return;
      await this.resolveThemenRelation();
    } catch (error) {
      console.log(error);
      this.$toasted.show("Fehler beim Laden der Themen", this.toasts.failure);
    } finally {
      this.loading.themen = false;
    }
  },
  methods: {
    setThemaUser(payload) {
      this.themaUser = payload;
    },
    async resolveThemenRelation() {
      const filterThemen = {
        filter: {
          name: this.show_themen,
        },
        fields: "*.*"
      };

      let themaId = null;
      let ansprechpartner_id;
      try {
        const response = await this.$directus.items("ansprechpartner_themen").readByQuery(filterThemen);

        if(response.data[0] != undefined) {
          themaId = response.data[0].id;
          ansprechpartner_id = response.data[0].ansprechpartner[0].ansprechpartner_id;
        }

      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden der Beziehung ansprechpartner_themen", this.toasts.failure);
      }

      try {
        if(themaId) {

          const responseAP = await this.$directus.items("ansprechpartner").readOne(ansprechpartner_id, {fields: "*.*"});
          const responseUser = responseAP.ansprechpartner; 
          const themaUserPL = {...responseAP.ansprechpartner, telefon: responseAP.telefon};

          this.setThemaUser(themaUserPL);  
          console.log("ansprechpartner"); 
          console.log(responseAP.ansprechpartner);                  
          if (responseUser.avatar) {
            await this.getUserAvatar(responseUser.avatar);
          }

          if(!responseUser.avatar) {
            const getDefaultAvatar = await this.$store.dispatch("images/getImgURL", {
              id: this.defaultAvatar,
              mode: "imgtag",
              format: "thumb-200-full",
              volatile:true
            });
            this.avatar = getDefaultAvatar.url;
          } 

                 
        }
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden des Thema Benutzers", this.toasts.failure);
      } finally {
        this.ready = true;
      }
    },
    //TODO: new image function
    async getUserAvatar(id) {      
      try {
        //await this.$directus.items("directus_files").readOne(id);        
        const responseImg = await this.$store.dispatch("images/getImgURL", {
          id: id,
          mode: "imgtag",
          format: "thumb-200-full",
          volatile: false
        });
        console.log("img");

        this.avatar = responseImg.url;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Fehler beim Laden des Benutzeravatars", this.toasts.failure);
      }
    },
  },
};
</script>

<style scoped>
.user-card .user-badge .badge {
  margin-bottom: 0px;
}

.badge svg {
  width: inherit !important;
  height: inherit !important;
}
</style>
